export const CHAT_COMPLETION_PARAMS = {
    HISTORY_LIMIT: {
        ALLOW_NEGATIVE: false,
        DECIMAL_SCALE: 0,
    },
    TEMPERATURE: {
        ALLOW_NEGATIVE: false
    },
    MAX_TOKENS: {
        DECIMAL_SCALE: 0,
        ALLOW_NEGATIVE: false
    },
    TOP_PROBABILITY: {
        ALLOW_NEGATIVE: false
    }
};
